import Users from "./Users.page";

export default Users;
